import { render } from "./ReportEmbed.vue?vue&type=template&id=69898fdd"
import script from "./ReportEmbed.vue?vue&type=script&lang=js"
export * from "./ReportEmbed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BT5DT1\\REPORT-WEB\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__